<div class="form-heading mt-4 mb-2">
  <h5>Organization Details</h5>
</div>
<form [formGroup]="inputForm">
  <div
    [ngClass]="{
      'one-field-layout': layout === ScreenlayoutConstant.ONE_FIELD_LAYOUT,
      'two-field-layout': layout === ScreenlayoutConstant.TWO_FIELDS_LAYOUT,
      'three-field-layout': layout === ScreenlayoutConstant.THREE_FIELDS_LAYOUT,
    }"
    class="mt-4"
  >
    <div class="column input-block">
      <label [for]="formControls.ORGANIZATION" class="form-label">
        Organization
        <span class="required">*</span>
      </label>
      <p-dropdown
        [id]="formControls.ORGANIZATION"
        [filter]="true"
        filterBy="key"
        optionLabel="key"
        optionValue="value"
        [options]="orgDetails.organizations"
        (onChange)="onOrganizationSelect($event)"
        [formControlName]="formControls.ORGANIZATION"
        placeholder="Select Organization"
      ></p-dropdown>
      <div
        *ngIf="
          (form[formControls.VERTICAL].errors &&
            form[formControls.ORGANIZATION].touched) ||
          form[formControls.ORGANIZATION].dirty
        "
      >
        <div *ngIf="form[formControls.ORGANIZATION].errors?.['required']">
          <small class="validation-error">Please select an organization</small>
        </div>
      </div>
    </div>
    <div class="column input-block">
      <label [for]="formControls.VERTICAL" class="form-label">
        Vertical
        <span class="required">*</span>
      </label>
      <p-dropdown
        [id]="formControls.VERTICAL"
        [filter]="true"
        filterBy="key"
        optionLabel="key"
        optionValue="value"
        [options]="orgDetails.verticals"
        (onChange)="onVerticalSelect($event)"
        [formControlName]="formControls.VERTICAL"
        placeholder="Select Vertical"
        [ngClass]="{
          'ng-invalid ng-dirty':
            form[formControls.VERTICAL].errors &&
            (form[formControls.VERTICAL].touched ||
              form[formControls.VERTICAL].dirty)
        }"
      ></p-dropdown>
      <div
        *ngIf="
          form[formControls.VERTICAL].touched ||
          form[formControls.VERTICAL].dirty
        "
      >
        <div *ngIf="form[formControls.VERTICAL].errors?.['required']">
          <small class="validation-error">Please select a vertical</small>
        </div>
      </div>
    </div>
    <div class="column input-block">
      <label [for]="formControls.DIVISION" class="form-label">
        Division
        <span class="required">*</span>
      </label>
      <p-dropdown
        [id]="formControls.DIVISION"
        [filter]="true"
        filterBy="key"
        optionLabel="key"
        optionValue="value"
        [options]="orgDetails.divisions"
        (onChange)="onDivisionSelect($event)"
        [formControlName]="formControls.DIVISION"
        placeholder="Select Division"
        [ngClass]="{
          'ng-invalid ng-dirty':
            form[formControls.DIVISION].errors &&
            (form[formControls.DIVISION].touched ||
              form[formControls.DIVISION].dirty)
        }"
      ></p-dropdown>
      <div
        *ngIf="
          form[formControls.DIVISION].touched ||
          form[formControls.DIVISION].dirty
        "
      >
        <div *ngIf="form[formControls.DIVISION].errors?.['required']">
          <small class="validation-error">Please select a division</small>
        </div>
      </div>
    </div>
    <div class="column input-block">
      <label [for]="formControls.DEPARTMENT" class="form-label">
        Department
        <span class="required">*</span>
      </label>
      <p-dropdown
        [id]="formControls.DEPARTMENT"
        [filter]="true"
        filterBy="key"
        optionLabel="key"
        optionValue="value"
        [options]="orgDetails.departments"
        [formControlName]="formControls.DEPARTMENT"
        placeholder="Select Department"
        [ngClass]="{
          'ng-invalid ng-dirty':
            form[formControls.DEPARTMENT].errors &&
            (form[formControls.DEPARTMENT].touched ||
              form[formControls.DEPARTMENT].dirty)
        }"
      ></p-dropdown>
      <div
        *ngIf="
          form[formControls.DEPARTMENT].touched ||
          form[formControls.DEPARTMENT].dirty
        "
      >
        <div *ngIf="form[formControls.DEPARTMENT].errors?.['required']">
          <small class="validation-error">Please select a department</small>
        </div>
      </div>
    </div>
  </div>
</form>
